import axios from "../../../utils/request"

function GET_LIST(params) {
    return axios.get("/activity/AHotActivityV2/index", {
        params: {
            ...params
        }
    } )
}
function ADD_DATA(params) {
    return  axios.get("/activity/AHotActivityV2/add",{
        params: {}
    } )
}
function EDIT_DATA(params) {
    return  axios.get("/activity/AHotActivityV2/edit",{
        params: {id:params}
    } )
}
function SUBMIT_ADD(params) {
    return  axios.post("/activity/AHotActivityV2/addPost",{...params} )
}
function SUBMIT_EDIT(params) {
    return  axios.post("/activity/AHotActivityV2/editPost",{...params} )
}


function CHANG_STATUS (params) {
    return  axios.post("/activity/AHotActivity/statusEdit",{status:params} )
}
function DELE(params) {
    return  axios.get("/activity/AHotActivityV2/delete",{
        params: {
            ids:params
        }
    } )
}
export default {
    GET_LIST,
    ADD_DATA,
    EDIT_DATA,
    SUBMIT_ADD,
    SUBMIT_EDIT,
    CHANG_STATUS,
    DELE,
}
